import { ILayoutEditorManagerBase } from '../layout-editor.manager';
import { UiManager } from '../ui/ui.manager';
import { AlbumPage } from '../../albam/albam';
import { ImageEditManager } from '../image-edit/image-edit.manager';
import { LayoutDataManager } from '../data/layout-data.manager';
import { CjContainer } from '../../model/cj-factory';
import { CJ_CONTAINER_NAME } from '../../model/cj-factory/cj-obj-name.collection';
import { CjTool } from '../../../utilities/cj-tool';

export class PreviewManager implements ILayoutEditorManagerBase {

  private uiManager!: UiManager;
  private layoutDataManager!: LayoutDataManager;
  private intervalTimerId = -1;
  private outCanvas: HTMLCanvasElement;

  constructor() {
    this.outCanvas = document.createElement('canvas');
  }

  initialize(): void {
  }

  destroy(): void {
  }

  di(
    uiManager: UiManager,
    layoutDataMng: LayoutDataManager,
  ): void {
    this.uiManager = uiManager;
    this.layoutDataManager = layoutDataMng;
  }

  start(canvas: HTMLCanvasElement | null, album: AlbumPage) {
    const interval = 3000;
    this.intervalTimerId = window.setInterval(() => {
      if (canvas) {
        this.makePreviewImage(canvas, album);
      }
    }, interval);
  }

  stop() {
    window.clearInterval(this.intervalTimerId);
  }

  makePreviewImage(canvas: HTMLCanvasElement, album: AlbumPage) {
    const quality = 0.8;
    const scale = 0.2;
    const format = 'image/jpeg';
    const ctx: CanvasRenderingContext2D = this.outCanvas.getContext('2d') as CanvasRenderingContext2D;
    if (!ctx) {
      return;
    }
    const w = album.parseData.templateData.size[0].virtual[0].$.width;
    const h = album.parseData.templateData.size[0].virtual[0].$.height
    this.outCanvas.width = w * scale;
    this.outCanvas.height = h * scale;
    // 天地線 ( 人寸線 ) ・中心線は編集用の補助線のためサムネイルには写さない ( 一時的に隠して撮り、撮影後に戻す )
    const restoreLines = this.hideAssistLines(album);
    try {
      ctx.drawImage(
        canvas,
        ImageEditManager.STAGE_CONTAINER_X, ImageEditManager.STAGE_CONTAINER_Y, w, h,
        0, 0, w * scale, h * scale,
      );
    } finally {
      restoreLines();
    }
    const url = this.outCanvas.toDataURL(format, quality);
    this.uiManager.emit(
      'r->l:preview:make',
      {
        url,
        album,
        callback: (list) => {
          this.layoutDataManager.dispatch('setPreviewList', { list, target: album });
        },
      },
    );
  }

  // - 天地線・中心線をキャプチャの間だけ非表示にし、元に戻す関数を返す -
  private hideAssistLines(album: AlbumPage): () => void {
    const restoreList: (() => void)[] = [];
    const stageContainer = album.imageEditManager?.stage;
    if (!stageContainer) return () => {};
    try {
      // 天地線 ( 人寸線 )
      const trimLines = stageContainer.getChildByName(CJ_CONTAINER_NAME.trimLine) as CjContainer | null;
      if (trimLines?.visible) {
        trimLines.visible = false;
        restoreList.push(() => trimLines.visible = true);
      }
      // 中心線 ( alphaで表示切替されている )
      const imageAreas: CjContainer[] = this.layoutDataManager.selector('getImageAreas', stageContainer.pageId) ?? [];
      imageAreas.forEach((imaCon) => {
        const line = CjTool.getCenterLine(imaCon);
        if (line?.alpha) {
          const alpha = line.alpha;
          line.alpha = 0;
          restoreList.push(() => line.alpha = alpha);
        }
      });
    } catch (e) {
      // 補助線の取得に失敗してもサムネイル生成自体は継続する
      console.error(e);
    }
    if (!restoreList.length) return () => {};
    stageContainer.stage?.update();
    return () => {
      restoreList.forEach((restore) => restore());
      stageContainer.stage?.update();
    };
  }

}
